import ACTIONS from '../actions';

const infoTree = (state = { team: {}, designerInfo: {} }, action) => {
    let newState = { team: {}, designerInfo: {} };
    switch (action.type) {
        case ACTIONS.CALENDAR_SETUP:
            newState = {
                ...state,
                date: action.dateKey,
                year: parseInt(action.year),
                month: parseInt(action.month),
                programType: action.programType,
                programLength: action.programLength
            };
            return newState;
        case ACTIONS.CALENDAR_SET_TEAM:
            return {
                ...state,
                team: action.team,
                athleteId: +action.athleteId || null
            };
        case ACTIONS.CALENDAR_SET_PROGRAM_ID:
            return {
                ...state,
                programId: action.programId
            };
        case ACTIONS.CALENDAR_LOAD_DAY_HEADERS:
            return {
                ...state,
                dayHeaders: {
                    status: action.days,
                    width: null
                }
            };
        case ACTIONS.CLEAR_INFO_TREE:
            return { team: {}, designerInfo: {} };
        case ACTIONS.DESIGNER_SET_INFO:
            return {
                ...state,
                designerInfo: action.info
            };
        default:
            return state;
    }
};

export default infoTree;
